import * as redirect from "./redirect";

export default redirect;
